import { render, staticRenderFns } from "./Double10_2021.vue?vue&type=template&id=ae628b72&scoped=true&"
import script from "./Double10_2021.vue?vue&type=script&lang=js&"
export * from "./Double10_2021.vue?vue&type=script&lang=js&"
import style0 from "./Double10_2021.vue?vue&type=style&index=0&id=ae628b72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae628b72",
  null
  
)

export default component.exports